import { render, staticRenderFns } from "./FoodyDeliveryRegister.vue?vue&type=template&id=6defdef8&scoped=true&"
import script from "./FoodyDeliveryRegister.vue?vue&type=script&lang=js&"
export * from "./FoodyDeliveryRegister.vue?vue&type=script&lang=js&"
import style0 from "./FoodyDeliveryRegister.vue?vue&type=style&index=0&id=6defdef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6defdef8",
  null
  
)

export default component.exports